export const POI_TYPE = {
  STORES: 2,
  SERVICES: 5,
  RESTAURANTS: 6,
  STORES_SERVICES: 32
};
